import React from 'react';
import BaseModal from './BaseModal';
import Input from '../forms/Input';
import ColorCheckbox from '../forms/ColorCheckbox';
import { sortBy } from 'lodash';

export default class PassModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passName: '',
      fromPass: null,
      statuses_active: {},
      submitted: false,
    };
  }

  componentDidMount() {
    const notRemoved = ['not_home', 'inaccessible'];

    let statuses_active = {};
    this.props.canvass.statuses.forEach((status) => {
      statuses_active[status.status] = !notRemoved.includes(status.status);
    });

    const newestPass = sortBy(this.props.canvass.passes, ['id'])[
      this.props.canvass.passes.length - 1
    ].id;

    const passName = this.props.canvass.title + ' Pass ' + (this.props.canvass.passes.length + 1);

    this.setState({ statuses_active, fromPass: +newestPass, passName });
  }

  handleCheckboxChange(status) {
    this.setState({
      statuses_active: {
        ...this.state.statuses_active,
        [status]: !this.state.statuses_active[status],
      },
    });
  }

  renderStatusesCheckBoxes() {
    let legend = [];
    const { statuses } = this.props.canvass;

    statuses.forEach((status) => {
      legend.push(
        <ColorCheckbox
          className={'_' + status.color}
          value={this.state.statuses_active[status.status]}
          title={status.display_text}
          key={status.id}
          handleChange={() => this.handleCheckboxChange(status.status)}
        />
      );
    });

    return legend;
  }

  onSubmit = () => {
    const { passName, fromPass, statuses_active } = this.state;
    let statusArr = ['NOT_REAL_STATUS']; // always pass a minimum of one argument

    this.setState({ submitted: true });

    Object.keys(statuses_active).forEach((status) => {
      if (statuses_active[status]) {
        statusArr.push(status);
      }
    });

    this.props.onSubmit({
      parent_pass_id: fromPass,
      new_pass_name: passName,
      statuses: statusArr,
    });
  };

  render() {
    return (
      <BaseModal
        title={'Create a New Pass for ' + this.props.canvass.title}
        open={true}
        center
        onClose={this.props.handlePassModalClose}
      >
        {this.state.submitted && (
          <div className={'wrapper'} style={{ margin: '2em' }}>
            <h6 className={'my-4 primary-text'}>
              We're building the new pass and we'll email you when it's done.
            </h6>
            <div className="button-wrapper mt-6">
              <button className="button button-outline" onClick={this.props.handlePassModalClose}>
                OK
              </button>
            </div>
          </div>
        )}
        {!this.state.submitted && (
          <div className={'wrapper'} style={{ margin: '2em' }}>
            <Input
              type="text"
              title="Pass Name"
              value={this.state.passName}
              onChange={(val) => this.setState({ passName: val })}
            />
            <Input
              type="select"
              title="From Pass"
              onChange={(val) => this.setState({ fromPass: +val })}
              options={this.props.canvass.passes.map((pass) => {
                return {
                  display: pass.name,
                  value: pass.id,
                };
              })}
              value={this.state.fromPass}
            />

            <div className="fieldWrapper">
              <label>Select statuses to remove from next pass</label>
              {this.renderStatusesCheckBoxes()}
            </div>
            <div className="button-wrapper mt-6">
              <button className="button" onClick={() => this.onSubmit()}>
                Submit
              </button>
              <button className="button button-outline" onClick={this.props.handlePassModalClose}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </BaseModal>
    );
  }
}
